/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetClientDto } from './GetClientDto';
import {
    GetClientDtoFromJSON,
    GetClientDtoFromJSONTyped,
    GetClientDtoToJSON,
} from './GetClientDto';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';

/**
 * 
 * @export
 * @interface GetContactDto
 */
export interface GetContactDto {
    /**
     * 
     * @type {string}
     * @memberof GetContactDto
     */
    id: string;
    /**
     * 
     * @type {GetClientDto}
     * @memberof GetContactDto
     */
    client: GetClientDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetContactDto
     */
    contactType: GetDictionaryDto;
    /**
     * 
     * @type {string}
     * @memberof GetContactDto
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetContactDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetContactDto interface.
 */
export function instanceOfGetContactDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "client" in value;
    isInstance = isInstance && "contactType" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetContactDtoFromJSON(json: any): GetContactDto {
    return GetContactDtoFromJSONTyped(json, false);
}

export function GetContactDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'client': GetClientDtoFromJSON(json['client']),
        'contactType': GetDictionaryDtoFromJSON(json['contactType']),
        'email': json['email'],
        'active': json['active'],
    };
}

export function GetContactDtoToJSON(value?: GetContactDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'client': GetClientDtoToJSON(value.client),
        'contactType': GetDictionaryDtoToJSON(value.contactType),
        'email': value.email,
        'active': value.active,
    };
}

